import type { ReactNode } from 'react';

export const symbol_wifi_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M784-91 411-463q-42 10-78 29.5T267-389q-15 12-33.5 13.5T201-388q-14-14-13-32.5t15-31.5q29-26 62-46t75-37L229-646q-35 18-68.5 40.5T98-558q-15 13-34 13.5T31-558q-14-14-12.5-32.5T34-622q30-27 62-50t65-41l-71-71q-9-9-9-21.5t9-21.5q9-9 21.5-9t21.5 9l694 694q9 9 9 21t-9 21q-9 9-21.5 9T784-91Zm-367-63q-27-27-27-63t27-63q27-27 63-27t63 27q27 27 27 63t-27 63q-27 27-63 27t-63-27Zm343-235q-14 14-33 14t-34-13q-32-27-71.5-57T549-500l-12-9q-15-11-7-29t28-14q57 11 104.5 35.5T754-454q15 13 17.5 32T760-389Zm169-169q-14 14-33.5 13.5T861-558q-83-70-178-111t-203-41q-37 0-71 4.5T352-693q-18 6-34.5-2.5T295-722q-6-18 2.5-35.5T324-780q36-11 75.5-15.5T480-800q128 0 241.5 48.5T926-622q14 13 15.5 31.5T929-558Z"
		/>
	</svg>
);
